/* YSL Marketing v2: site behaviour. Plain JS, no dependencies. */
(function () {
  'use strict';

  /* GHL inbound webhooks for the Playbook opt-ins.
     Paste each URL once its GHL workflow exists. While a URL is empty,
     that page's "Want this in your inbox?" card stays hidden. */
  var WEBHOOKS = {
    'revenue-calculator': '',
    'handover-planner': ''
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var num = function (v) { var x = parseFloat(v); return isFinite(x) && x > 0 ? x : 0; };
  var money = function (v) { return '$' + Math.round(v).toLocaleString('en-AU'); };
  var put = function (root, key, val) { $$('[data-o="' + key + '"]', root).forEach(function (el) { el.textContent = val; }); };
  var push = function (o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); };

  /* Mobile menu: close on outside click or Escape */
  $$('details.navmenu').forEach(function (d) {
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; $('summary', d).focus(); } });
  });

  /* Cookie notice */
  try {
    var k = 'ysl_cookie_ok', bar = $('#cookiebar');
    if (bar && !localStorage.getItem(k)) {
      var reveal = function () {
        if (window.scrollY < 120) return;
        window.removeEventListener('scroll', reveal);
        bar.hidden = false;
        document.body.style.paddingBottom = bar.offsetHeight + 'px';
      };
      window.addEventListener('scroll', reveal, { passive: true });
      var done = function (v) { try { localStorage.setItem(k, v); } catch (e) {} bar.hidden = true; document.body.style.paddingBottom = ''; };
      $('#cookie-accept').onclick = function () { done('accept'); };
      $('#cookie-decline').onclick = function () { done('decline'); };
    }
  } catch (e) {}

  /* Home: revenue tabs */
  var tiers = $$('[data-tier]');
  if (tiers.length) {
    $$('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pick = btn.getAttribute('data-pick');
        tiers.forEach(function (t) { t.hidden = t.getAttribute('data-tier') !== pick; });
        var active = $('[data-tier="' + pick + '"] [data-pick="' + pick + '"]');
        if (active) active.focus();
        push({ event: 'revenue_tab', tier: pick });
      });
    });
  }

  /* Contact: service dropdown explanations, preselect from ?service=, track submit */
  var svc = $('[data-svc-select]');
  if (svc) {
    var showSvc = function () {
      $$('[data-svc]').forEach(function (el) { el.hidden = el.getAttribute('data-svc') !== svc.value; });
    };
    try {
      var want = new URLSearchParams(location.search).get('service');
      if (want && $('option[value="' + want.replace(/[^a-z-]/g, '') + '"]', svc)) svc.value = want;
    } catch (e) {}
    svc.addEventListener('change', showSvc);
    showSvc();
    var enq = $('#ysl-enquiry');
    if (enq) enq.addEventListener('submit', function () { push({ event: 'enquiry_submit', service: svc.value || 'none' }); });
  }

  /* Part Two: Revenue Calculator */
  var rc = $('[data-revcalc]');
  if (rc) {
    var rcRoot = rc.parentNode;
    var calcRev = function () {
      var v = {};
      $$('[data-k]', rc).forEach(function (el) { v[el.getAttribute('data-k')] = el.value; });
      var onlineMonth = num(v.rev) * Math.min(num(v.online), 100) / 100 / 12;
      var emailMonth = num(v.email);
      var targetMonth = onlineMonth * num(v.target) / 100;
      var gapYear = Math.max(0, targetMonth - emailMonth) * 12;
      var share = onlineMonth > 0 ? Math.round(emailMonth / onlineMonth * 100) : 0;
      var factor = v.trace === 'no' ? 1 : v.trace === 'rough' ? 0.5 : 0;
      var untraced = num(v.ads) * 12 * factor;
      var headline, detail;
      if (gapYear === 0 && untraced === 0) {
        headline = 'Your email is at or above target, and you can trace your sales.';
        detail = 'That puts you ahead of most founder-led brands. The next gains come from growth: new channels, new customers and better ads.';
      } else if (gapYear >= untraced) {
        headline = 'Your email list could be earning about ' + money(gapYear) + ' more a year.';
        detail = 'These are people who already know your brand. Start here, because it pays from the day it is switched on, with no extra ad spend.';
      } else {
        headline = money(untraced) + ' a year of ad spend you can’t trace to a sale.';
        detail = 'Not wasted, but not judged. Until each sale is linked to a channel, there is no way to know which ads to scale and which to cut.';
      }
      put(rcRoot, 'target', num(v.target));
      put(rcRoot, 'gapYear', money(gapYear));
      put(rcRoot, 'untraced', money(untraced));
      put(rcRoot, 'emailNow', share + '%');
      put(rcRoot, 'emailTarget', money(targetMonth));
      put(rcRoot, 'headline', headline);
      put(rcRoot, 'detail', detail);
      return { calc_rev_gap_year: money(gapYear), calc_rev_untraced_year: money(untraced), calc_rev_email_share: share + '%', calc_rev_headline: headline };
    };
    rc.addEventListener('input', calcRev);
    rc.addEventListener('change', calcRev);
    calcRev();
    optin('revenue-calculator', calcRev);
  }

  /* Part Three: Hand-over Planner */
  var ho = $('[data-handover]');
  if (ho) {
    var hoRoot = ho.parentNode;
    var tasks = [
      { name: 'Posting and scheduling social', hours: 3, who: 'anyone' },
      { name: 'Shooting and editing content', hours: 3, who: 'brief' },
      { name: 'Writing and sending emails', hours: 2, who: 'brief' },
      { name: 'Website updates and fixes', hours: 1, who: 'anyone' },
      { name: 'Running ads', hours: 1, who: 'brief' },
      { name: 'Pulling numbers and reports', hours: 1, who: 'anyone' },
      { name: 'Briefing and checking freelancers', hours: 2, who: 'brief' },
      { name: 'Planning campaigns', hours: 1, who: 'brief' },
      { name: 'Brand voice and final approvals', hours: 1, who: 'me' }
    ];
    var field = 'font: inherit; font-size: 16px; padding: 10px 12px; border: 1px solid #C9BEB0; border-radius: 12px; background: #FCFCF5; min-height: 44px; box-sizing: border-box; width: 100%';
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    $('[data-rows]', ho).outerHTML = tasks.map(function (t, i) {
      return '<div class="trow" data-i="' + i + '">' +
        '<p style="margin: 0; font-size: 16px; font-weight: 700">' + esc(t.name) + '</p>' +
        '<input type="number" min="0" step="0.5" inputmode="decimal" aria-label="Hours a week: ' + esc(t.name) + '" value="' + t.hours + '" data-f="hours" style="' + field + '">' +
        '<select aria-label="Who could do it: ' + esc(t.name) + '" data-f="who" style="' + field + '">' +
        ['anyone|Anyone, with a checklist', 'brief|Someone senior, with a brief', 'me|Only me'].map(function (o) {
          var p = o.split('|'); return '<option value="' + p[0] + '"' + (p[0] === t.who ? ' selected' : '') + '>' + p[1] + '</option>';
        }).join('') + '</select></div>';
    }).join('');
    var fmt = function (v) { return (Math.round(v * 10) / 10).toLocaleString('en-AU'); };
    var weight = { anyone: 3, brief: 2, me: 0 };
    var calcHo = function () {
      $$('.trow', ho).forEach(function (row) {
        var t = tasks[+row.getAttribute('data-i')];
        t.hours = $('[data-f="hours"]', row).value;
        t.who = $('[data-f="who"]', row).value;
      });
      var live = tasks.filter(function (t) { return num(t.hours) > 0; });
      var hand = live.filter(function (t) { return t.who !== 'me'; })
        .sort(function (a, b) { return num(b.hours) * weight[b.who] - num(a.hours) * weight[a.who]; });
      var keep = live.filter(function (t) { return t.who === 'me'; });
      var handH = hand.reduce(function (s, t) { return s + num(t.hours); }, 0);
      var keepH = keep.reduce(function (s, t) { return s + num(t.hours); }, 0);
      put(hoRoot, 'handHours', fmt(handH));
      put(hoRoot, 'keepHours', fmt(keepH));
      var order = hand.slice(0, 5);
      $('[data-order]', hoRoot).innerHTML = order.map(function (t, k) {
        var note = fmt(num(t.hours)) + (num(t.hours) === 1 ? ' hour' : ' hours') + ' a week · ' + (t.who === 'anyone' ? 'anyone, with a checklist' : 'someone senior, with a brief');
        return '<li style="background: #5A1A1A; border-radius: 16px; padding: 16px 18px; display: flex; gap: 14px; align-items: baseline"><span style="font-family: \'DM Serif Display\', serif; font-size: 30px; line-height: 1; color: #A9C3EA">' + (k + 1) + '</span><span><span style="display: block; font-size: 17px; font-weight: 700">' + esc(t.name) + '</span><span style="display: block; margin-top: 4px; font-size: 14px; color: #E8DCCB">' + note + '</span></span></li>';
      }).join('');
      var hk = $('[data-haskeep]', hoRoot);
      if (hk) hk.hidden = keep.length === 0;
      put(hoRoot, 'keepList', keep.map(function (t) { return t.name.toLowerCase(); }).join(', '));
      return {
        calc_handover_hours: fmt(handH), calc_keep_hours: fmt(keepH),
        calc_handover_order: order.map(function (t, k) { return (k + 1) + '. ' + t.name; }).join(' | ')
      };
    };
    ho.addEventListener('input', calcHo);
    ho.addEventListener('change', calcHo);
    calcHo();
    optin('handover-planner', calcHo);
  }

  /* Opt-in cards (Parts Two and Three) */
  function optin(tag, results) {
    var card = $('[data-optin="' + tag + '"]');
    if (!card) return;
    var url = WEBHOOKS[tag];
    if (!url) { card.hidden = true; return; }
    var form = $('[data-optin-form]', card);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var data = new FormData(form);
      data.append('tag', tag);
      data.append('source_page', location.pathname);
      var r = results();
      Object.keys(r).forEach(function (k) { data.append(k, r[k]); });
      var btn = $('button[type="submit"]', form);
      btn.disabled = true;
      fetch(url, { method: 'POST', mode: 'no-cors', body: data }).then(function () {
        form.hidden = true;
        $('[data-optin-done]', card).hidden = false;
        push({ event: 'generate_lead', lead_source: tag });
      }).catch(function () { btn.disabled = false; });
    });
  }
})();
